import React from 'react';
import BottomNav from '../components/BottomNav';

const WealthLuxury = () => {
  return (
    <div className="page-container">
      <div className="page-wrapper">
        <h1 className="page-title">Wealth & Luxury</h1>
        <div className="underline"></div>
        <p className="page-subtitle">Experience Unparalleled Luxury</p>
        
        <div className="card">
          <p>
            Discover a world where wealth meets luxury. Access exclusive experiences, 
            premium services, and curated opportunities designed for discerning individuals.
          </p>
          
          <div className="service-features">
            <div className="feature-item">
              <h3>Exclusive Access</h3>
              <p>Private events, VIP experiences, and members-only privileges</p>
            </div>
            <div className="feature-item">
              <h3>Premium Services</h3>
              <p>White-glove service across all aspects of luxury living</p>
            </div>
            <div className="feature-item">
              <h3>Global Network</h3>
              <p>Connect with like-minded individuals worldwide</p>
            </div>
          </div>
        </div>
      </div>
      
      <BottomNav />
    </div>
  );
};

export default WealthLuxury;
